<template>
    <vx-button @click.prevent="router.push(props.to)"
        :href="href">
        <slot />
    </vx-button>
</template>

<script setup lang="ts">
import { VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';

const props = defineProps<{
    to: RouteLocationRaw;
}>();

const router = useRouter();

const href = computed((): string => {
    return router.resolve(props.to).href;
});
</script>
